/*
 *   File : sip-dates.js
 *   Author : https://evoqins.com
 *   Description : SIP date modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from "react";

// Component
import { PrimaryBtn, SecondaryBtn } from "../cta";
import { Datepicker } from "../input";
import { Toast } from '../note';

import style from "../../styles/components/sip-dates.module.scss"
import styles from '../../styles/components/fundClass.module.scss';

import devconfig from '../../config/config';
import APIPost from '../../services/postApi';


const PauseScheduledCart = React.memo((props) => {

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("")
    const [toastMessage, setToastMessage] = useState(null);

    useEffect(() => {
        var my_modal = document.getElementById("pause-scheduled-cart");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.handleCloseDateModal();
        });
        //eslint-disable-next-line
    }, [props.handleCloseDateModal]);

    useEffect(() => {
        if (toastMessage !== null) {
            setTimeout(() => {
                setToastMessage(null);
            }, 4000);
        }
    }, [toastMessage])


    const _handleCloseModal = () => {
        document.getElementById("close-pscm").dispatchEvent(new Event("click"));
    };

    const _pauseCart = () => {
        const url = devconfig.admin + '/basket-order/pause';
        let payload = JSON.stringify({
            cart_id: props.cartId,
            start_date: fromDate,
            end_date: toDate,
        });
        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                setToastMessage({ type: 'success', message: 'Scheduled cart paused!' });
                setTimeout(() => {
                    _handleCloseModal();
                    props.updatedFund(true)
                }, 1000);
            } else {
                setToastMessage({ type: 'error', message: response.message });
            }
        })
    }
    return (
        <>
            <div className={`modal fade ${styles.e_add_fund} ${style.e_sip_modal}`}
                id="pause-scheduled-cart"
                tabIndex="-1"
                aria-labelledby="pause-scheduled-cart"
                aria-hidden="true"
                data-bs-keyboard="false">
                <div className={`modal-dialog position-relative modal-dialog-centered e-w-320px ${style.e_dialog}`}>
                    <div className={`modal-content ${style.e_content}`}>

                        <div className="">
                            <div className="d-flex align-items-center justify-content-between pt-2">
                                <h6 className='mb-0'>
                                    Pause Autopay
                                </h6>
                                <button id="close-pscm"
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={_handleCloseModal} >
                                </button>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 mb-3">
                                <label>From</label>
                                <Datepicker
                                    placeholder="Select the Date"
                                    value={fromDate}
                                    onChange={(value) => {

                                        setFromDate(value)
                                    }}
                                />
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label>To</label>
                                <Datepicker
                                    placeholder="Select the Date"
                                    value={toDate}
                                    onChange={(value) => {

                                        setToDate(value)
                                    }}
                                />
                            </div>
                            <div className='mt-4 col-12 d-flex justify-content-end'>
                                <SecondaryBtn
                                    name="Cancel"
                                    className={`${styles.e_cancel} e-cancel`}
                                    cancel="modal"
                                />
                                <PrimaryBtn name="Pause"
                                    className="padding-10px-tb "
                                    handleClick={_pauseCart} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                toastMessage !== null ?
                    <Toast data={toastMessage.message}
                        type={toastMessage.type}
                        id="2" />
                    :
                    null
            }
        </>
    )
})

export default PauseScheduledCart;

PauseScheduledCart.defaultProps = {
}